import React, { useEffect, useState } from "react";
import { getHsUid } from "../happyschool_static/hsAuth";
import { createSubject, createTopic } from "./quiz3Utils";
import Quiz3TreeBrowser from "./Quiz3TreeBrowser";
import { useResizableWidth, ResizeDivider } from "./useResizableWidth";
import Quiz3QuestionBank from "./Quiz3QuestionBank";
import Quiz3QuizForm from "./Quiz3QuizForm";
import Quiz3TopicTheory from "./Quiz3TopicTheory";

const TABS = [
  { key: "tree", label: "Cây môn học/chủ đề" },
  { key: "theory", label: "Lý thuyết" },
  { key: "bank", label: "Ngân hàng câu hỏi" },
  { key: "quiz", label: "Tạo đề thi" },
];

// Khu vực Soạn câu hỏi (QA-01..QA-06b) — hoàn toàn công khai, ai đăng nhập
// cũng soạn được; chỉ người tạo mới sửa/xóa được nội dung của chính mình.
const Quiz3Author = () => {
  const [uid, setUid] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const [tab, setTab] = useState("tree");
  const [selected, setSelected] = useState({ subjectId: null, topicId: null, key: null });
  // Không còn real-time (onValue) — sau khi thêm môn/chủ đề, tăng reloadKey để
  // Quiz3TreeBrowser tải lại cây từ API.
  const [reloadKey, setReloadKey] = useState(0);
  const { width: treeWidth, onDragStart } = useResizableWidth(280, 180, 720);

  useEffect(() => {
    setUid(getHsUid());
    setAuthChecked(true);
  }, []);

  const handleSelectNode = (subjectId, topicId) => {
    setSelected({ subjectId, topicId, key: topicId ? `topic:${topicId}` : `subject:${subjectId}` });
  };

  const handleAddSubject = async () => {
    const name = window.prompt("Tên môn học mới:");
    if (name && name.trim()) {
      await createSubject(name.trim());
      setReloadKey((k) => k + 1);
    }
  };

  const handleAddTopic = async (subjectId, parentTopicId) => {
    const name = window.prompt(parentTopicId ? "Tên chủ đề con mới:" : "Tên chủ đề mới:");
    if (name && name.trim()) {
      await createTopic(subjectId, parentTopicId, name.trim());
      setReloadKey((k) => k + 1);
    }
  };

  if (!authChecked) {
    return <p style={{ padding: 24, color: "#6b7280" }}>Đang tải...</p>;
  }

  if (!uid) {
    return <p style={{ padding: 24, color: "#6b7280" }}>Bạn cần đăng nhập để soạn câu hỏi.</p>;
  }

  return (
    <div style={{ padding: 24, maxWidth: 1200, margin: "0 auto" }}>
      <h2 style={{ margin: "0 0 4px 0" }}>Soạn câu hỏi</h2>
      <p style={{ color: "#6b7280", marginTop: 0, marginBottom: 20 }}>
        Nội dung hoàn toàn công khai — ai đăng nhập cũng soạn được; chỉ chính bạn mới sửa/xóa được câu hỏi/đề bạn
        đã tạo.
      </p>

      <div style={{ display: "flex", gap: 8, marginBottom: 20, borderBottom: "1px solid #e5e7eb" }}>
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            style={{
              padding: "10px 16px",
              border: "none",
              background: "none",
              cursor: "pointer",
              fontWeight: tab === t.key ? 700 : 400,
              color: tab === t.key ? "#2563eb" : "#374151",
              borderBottom: tab === t.key ? "2px solid #2563eb" : "2px solid transparent",
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div style={{ display: "flex", gap: 16, alignItems: "stretch" }}>
        <div style={{ width: treeWidth, flexShrink: 0, overflow: "auto" }}>
          <h4 style={{ marginTop: 0 }}>Cây môn học/chủ đề</h4>
          <Quiz3TreeBrowser
            selectedKey={selected.key}
            onSelectNode={handleSelectNode}
            manageMode
            onAddSubject={handleAddSubject}
            onAddTopic={handleAddTopic}
            reloadKey={reloadKey}
          />
        </div>

        {/* Thanh chia dọc kéo được giữa tree và box phải */}
        <ResizeDivider onDragStart={onDragStart} />

        <div style={{ flex: 1, minWidth: 0 }}>
          {tab === "tree" && (
            <p style={{ color: "#6b7280" }}>
              Dùng cây bên trái để thêm môn học/chủ đề mới, hoặc chọn 1 node để soạn lý thuyết/câu hỏi ở các tab
              bên cạnh.
            </p>
          )}
          {tab === "theory" && <Quiz3TopicTheory topicId={selected.topicId} />}
          {tab === "bank" && <Quiz3QuestionBank uid={uid} subjectId={selected.subjectId} topicId={selected.topicId} />}
          {tab === "quiz" && (
            <Quiz3QuizForm uid={uid} subjectId={selected.subjectId} topicId={selected.topicId} onDone={() => {}} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Quiz3Author;
